import * as Types from '../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NewExpenseMutationMutationVariables = Types.Exact<{
  input: Types.ExpenseInput;
}>;


export type NewExpenseMutationMutation = { __typename?: 'Mutation', upsertExpense: { __typename?: 'Expense', id: string, createdAt: any, expenseNumber: number, updatedAt: any, amount?: number | null, taxAmount?: number | null, paidAt?: any | null, paidTo?: string | null, category?: string | null, description?: string | null, paymentType?: Types.ExpensePaymentType | null, images: Array<{ __typename?: 'ExpenseImage', url: string, fileName: string }>, job?: { __typename?: 'Job', jobMetadata: { __typename?: 'JobMetadata', id: string, jobNumber: number, totalDue?: number | null, totalPaid?: number | null, timeCompleted?: any | null, createdAt: any, type?: Types.JobType | null, frontDeskComments?: string | null, mechanicComments?: string | null, estimateAmount?: number | null, mechanicShopStatus?: Types.JobMechanicShopStatus | null, status: Types.JobStatus }, customer?: { __typename?: 'Customer', firstName?: string | null, lastName?: string | null, id: string, email?: string | null, phoneNumber?: string | null } | null, car?: { __typename?: 'Car', id: string, make?: string | null, model?: string | null, year?: number | null, colour?: string | null } | null, invoice?: { __typename?: 'Invoice', invoiceMetadata: { __typename?: 'InvoiceMetadata', id: string, discount?: number | null, taxPercentage?: number | null, subtotal?: number | null } } | null, payments: Array<{ __typename?: 'Payment', id: string, settledAmount: number, status?: Types.CardPaymentStatus | null, type: Types.PaymentType, squarePaymentId?: string | null, terminalCheckoutId?: string | null }> } | null } };


export const NewExpenseMutationDocument = gql`
    mutation NewExpenseMutation($input: ExpenseInput!) {
  upsertExpense(input: $input) {
    id
    createdAt
    expenseNumber
    updatedAt
    amount
    taxAmount
    paidAt
    paidTo
    category
    description
    paymentType
    images {
      url
      fileName
    }
    job {
      jobMetadata {
        id
        jobNumber
        id
        totalDue
        totalPaid
        timeCompleted
        createdAt
        type
        frontDeskComments
        mechanicComments
        estimateAmount
        jobNumber
        mechanicShopStatus
        status
      }
      customer {
        firstName
        lastName
        id
        email
        phoneNumber
      }
      car {
        id
        make
        model
        year
        colour
      }
      invoice {
        invoiceMetadata {
          id
          discount
          taxPercentage
          subtotal
        }
      }
      payments {
        id
        settledAmount
        status
        type
        squarePaymentId
        terminalCheckoutId
      }
    }
  }
}
    `;
export type NewExpenseMutationMutationFn = Apollo.MutationFunction<NewExpenseMutationMutation, NewExpenseMutationMutationVariables>;

/**
 * __useNewExpenseMutationMutation__
 *
 * To run a mutation, you first call `useNewExpenseMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewExpenseMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newExpenseMutationMutation, { data, loading, error }] = useNewExpenseMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewExpenseMutationMutation(baseOptions?: Apollo.MutationHookOptions<NewExpenseMutationMutation, NewExpenseMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewExpenseMutationMutation, NewExpenseMutationMutationVariables>(NewExpenseMutationDocument, options);
      }
export type NewExpenseMutationMutationHookResult = ReturnType<typeof useNewExpenseMutationMutation>;
export type NewExpenseMutationMutationResult = Apollo.MutationResult<NewExpenseMutationMutation>;
export type NewExpenseMutationMutationOptions = Apollo.BaseMutationOptions<NewExpenseMutationMutation, NewExpenseMutationMutationVariables>;